import throttle from 'lodash/throttle'
import { isTouchDevice } from '../base/utils'

const INTERVAL_DURATION = 6000

class MiniCarousel {
  constructor(n) {
    const node = n
    const itemsNode = node.querySelector('.mini-carousel__items')
    const items = node.querySelectorAll('.mini-carousel__item')
    const pager = node.querySelector('.mini-carousel__pager')

    let activePageIndex = 0
    let interval = null

    // resize carousel item container's height to match with the active item's height
    const onResize = () => {
      if (node.querySelector('.mini-carousel__item--is-active')) {
        node.querySelector('.mini-carousel__items').style.height = `${
          node.querySelector('.mini-carousel__item--is-active').offsetHeight
        }px`
      }
    }

    // set carousel's auto-rotation interval
    const initInterval = () => {
      interval = setInterval(() => {
        const index = activePageIndex + 1 < items.length ? activePageIndex + 1 : 0
        setActivePage(index)
      }, INTERVAL_DURATION)
    }

    // init carousel item actions
    const initItems = () => {
      node.querySelectorAll('.mini-carousel__item').forEach((item, i) => {
        item.dataset.index = i
        item.addEventListener(isTouchDevice() ? 'touchstart' : 'mouseover', e => {
          const video = e.currentTarget.querySelector('video')
          if (video) video.play()
          itemsNode.classList.add('mini-carousel__items--on-item-hover')
          clearInterval(interval)
        })

        item.addEventListener(isTouchDevice() ? 'touchend' : 'mouseout', e => {
          const video = e.currentTarget.querySelector('video')
          if (video) video.pause()
          itemsNode.classList.remove('mini-carousel__items--on-item-hover')
          initInterval()
        })

        if (item.querySelector('video')) {
          item.querySelector('video').addEventListener('loadedmetadata', () => {
            if (item.classList.contains('mini-carousel__item--is-active')) {
              onResize()
            }
          })
        }
      })
    }

    // init carousel pager action
    const setActivePage = index => {
      pager.children[activePageIndex].classList.remove('is-active')
      pager.children[index].classList.add('is-active')

      items[activePageIndex].classList.remove('mini-carousel__item--is-active')

      items.forEach(item => {
        if (Number(item.dataset.index) < index) {
          item.classList.add('mini-carousel__item--out')
        } else {
          item.classList.remove('mini-carousel__item--out')
        }
      })

      items[index].classList.add('mini-carousel__item--is-active')

      onResize(node)

      activePageIndex = Number(index)
    }

    const initPager = () => {
      // init items
      items.forEach((item, i) => {
        const page = document.createElement('li')
        page.className = 'mini-carousel__pager__page'
        page.dataset.index = i
        pager.appendChild(page)

        page.addEventListener('click', e => {
          const index = e.currentTarget.dataset.index
          setActivePage(index)
          clearInterval(interval)
          initInterval()
        })
      })
    }

    // add basic swipe gestures
    const initGestures = () => {
      let startX = null
      node.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX
      })
      node.addEventListener('touchend', e => {
        const endX = e.changedTouches[0].clientX
        if (endX > startX + 10) {
          // swipe left
          setActivePage(activePageIndex - 1 < 0 ? 0 : activePageIndex - 1)
        } else if (endX < startX - 10) {
          // swipe right
          setActivePage(activePageIndex + 1 < items.length ? activePageIndex + 1 : items.length - 1)
        }
      })
    }

    window.addEventListener(
      'resize',
      throttle(() => {
        onResize(node)
      }, 100)
    )

    onResize()
    initItems()
    initPager()
    initInterval()

    if (isTouchDevice()) initGestures()

    // start carousel auto-rotation
    pager.children[activePageIndex].click()
  }
}

export default MiniCarousel
